export const DATE_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
  },
};



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/constants/date-format.ts